import * as payoutIcon       from '../../assets/fontawesome/trophy-solid.svg'
import * as gameGuideIcon    from '../../assets/fontawesome/info-circle-solid.svg'
import * as winLinesWaysIcon from '../../assets/fontawesome/list-ol-solid.svg'
import * as historyIcon      from '../../assets/fontawesome/stopwatch-solid.svg'
import * as settingsIcon     from '../../assets/fontawesome/cog-solid.svg'
import * as homeMobIcon      from '../../assets/mobile/landscape/menu-footer/home/mb-ls-btn-bright-home.png'
import * as freespinsBtn     from '../../assets/game/buy-free-spins-btn.png'
import * as exitDTIcon       from '../../assets/fontawesome/times-circle-solid.svg'
import * as exitMobIcon      from '../../assets/fontawesome/times-solid.svg'

/**
 * @file Defines the {@link ICONS} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/**
 * Reference to all icons used with new UI
 */
export const ICONS = {

    /** Exit icons */
    exit: {

        desktop: exitDTIcon,
        mobile:  exitMobIcon

    },
    
    /** Buy freespins icon */
    freespins: freespinsBtn,
    
    /** Home mobile icon */
    home: homeMobIcon,
    
    /** Game guide icon */
    gameGuide: gameGuideIcon,

    /** Game history icon */
    history: historyIcon,
    
    /** Payout icon */
    payout: payoutIcon,

    /** Settings icon */
    settings: settingsIcon,

    /** Win lines/ways icon */
    winLinesWays: winLinesWaysIcon

}